import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Select, MenuItem } from '@mui/material';
import { getRoles } from '@utils/helpers';
import { useAuth } from '@contexts/AuthContext';

const RoleSelect = forwardRef(({ emptyLabel, ...params }, ref) => {
    const { t } = useTranslation();
    const { user: currentUser } = useAuth();

    return (
        <Select ref={ref} {...params} >
            {emptyLabel && <MenuItem value="">{emptyLabel}</MenuItem>}
            {getRoles(t, currentUser.role).map((role) => (
                <MenuItem key={role.value} value={role.value}>
                    {role.label}
                </MenuItem>
            ))}
        </Select>
    );
});

export default RoleSelect;